import { SelectValue } from '../../../Components/Base/Select/Select';
import {
	PaginationInputOrder,
	TermItem,
	useLazyTermItemsQuery,
} from '../../../graphql/graphql';

export interface TermItemOption extends SelectValue {
	termItem: TermItem;
}

interface TermItemSelectParams {
	termType: string;
	labelTransform?: (termItem: TermItem) => string;
	useValue?: boolean;
	filter?: {
		value2?: string;
	};
	take?: number;
	order?: PaginationInputOrder;
}

export default function useTermItemSelect(params: TermItemSelectParams) {
	const {
		termType,
		labelTransform,
		useValue = false,
		filter,
		take,
		order,
	} = params;
	const [getTermItems] = useLazyTermItemsQuery();

	const handleFindOptions = async (search?: string) => {
		const params = {
			termType,
			filter,
			fullText: search,
			take,
			pagination: order ? { order, take } : null,
		};

		const { termItems } = await getTermItems(params).unwrap();

		const options: TermItemOption[] = [];

		// @ts-ignore
		(termItems?.data || []).map((termItem: TermItem) => {
			options.push({
				label: labelTransform ? labelTransform(termItem) : termItem.name!,
				value: useValue ? termItem.value?.toString() || '' : termItem.id,
				termItem: termItem,
			});
		});

		return options;
	};

	return {
		termItemSelectOptions: handleFindOptions,
	};
}
